const RightColumnWidget = () => import(/* webpackChunkName: "RcLifeRightColumnWidget" */ './RightColumnWidget.vue');
const CenterColumnWidget = () => import(/* webpackChunkName: "RcLifeHpCenterColumnWidget" */ './HpCenterColumnWidget.vue');

function init_vue_center_column_widget(selector)
{
    window.rclife_center_column = new Vue({
        name: 'rc-life-center-column-widget',
        el: selector,
        render: h => h(CenterColumnWidget),
    });
}

function init_vue_rigth_column_widget(selector)
{
    window.rclife_right_column = new Vue({
        name: 'rc-life-right-column-widget',
        el: selector,
        render: h => h(RightColumnWidget),
    });
}

function should_load_widget(selector){

    if( window.$(selector).length > 0 && window.$(selector).inViewport(30) ){
        return true;
    }

    return false;
}

function lazy_init_widget(selector, widget_callback)
{
    var lazy_init_callback = function(){
        if( should_load_widget(selector) ){
            widget_callback(selector);
            $(window).off("scroll rezise", lazy_init_callback);
        }
    }

    $(window).on('scroll rezise', lazy_init_callback).scroll().resize();
}

function init_widget(selector, widget_callback)
{
    if( should_load_widget(selector) ){
        widget_callback(selector);
    }else{
        lazy_init_widget(selector, widget_callback);
    }
}

function init_rc_life_widgets()
{
    let rc_selector = '#rclife_widget_right_column';
    let center_selector = '#rclife_widget_center_column';

    init_widget(rc_selector, init_vue_rigth_column_widget);
    init_widget(center_selector, init_vue_center_column_widget);
}

export default init_rc_life_widgets;